module.exports = __webpack_public_path__ + "img/stiker_drawed.1833d1f3.png";